
import singleTextMixin from './SingleTextMixin.vue'

export default {
  name: 'heading'

  mixins: [singleTextMixin]

  data: -> {
    blockCss: 'heading'
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/HeadingBlock.vue